export const UnderElement =  ()=>{
    return (
        <div className="container">
            カードの下にあるカードの情報です。非推奨です
            <p><img src={`${process.env.PUBLIC_URL}/dialogbox_under.png`}></img></p>
        </div>
    )
}
